module.exports = __webpack_public_path__ + "static/media/lost.84867c1b.svg";